import React from 'react'
import PropTypes from 'prop-types'
import error from '../404.png'

export default class Error extends React.Component {
  render () {
    return (
      <div id="mainContainer">
        <div id="designBorder">

          <div id="main-page" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
            <img src={error} style={{ width: '100%', maxWidth: 400, margin: '0 auto', padding: 0 }} alt="Error"/>
            <div style={{ width: '100%' }}>
              <p id="error-1">404</p>
              <p id="error-2">Aha! You see! You can be wrong!</p>
              <p id="error-3">(or it could be us)...</p>
              <p id="error-4">...either way, you should probably</p>
              <button id="error-5" className="save" onClick={this.props.onClick}>Go back to the Homepage</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
Error.propTypes = {
  onClick: PropTypes.func.isRequired
}
